import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import 'react-alice-carousel/lib/alice-carousel.css';
import './reviews.scss';
import Review from './review.js';
import dataReviews from './reviews.json';
import Title from '../../elements/title';
import Carousel from 'react-alice-carousel';
import breakpoints from '../../../styles/variables.scss';

const Reviews = () => {
	const sm =
		typeof document !== `undefined` ? breakpoints.sm.replace(/\D+/, '') : '';
	const md =
		typeof document !== `undefined` ? breakpoints.md.replace(/\D+/, '') : '';
	const lg =
		typeof document !== `undefined` ? breakpoints.lg.replace(/\D+/, '') : '';

	const [activeIndex, setActiveIndex] = useState(0);
	const [slides] = useState(
		dataReviews.map((person) => (
			<Review
				key={person.id}
				name={person.name}
				bio={person.bio}
				text={person.text}
				image={person.image}
			/>
		))
	);
	const [responsive] = useState({
		1800: { items: 5 },
		1300: { items: 4 },
		[lg]: { items: 3 },
		[md]: { items: 3 },
		[sm]: { items: 2 },
		0: { items: 1 },
	});

	const onSlideChange = (e) => setActiveIndex(e.item);

	return (
		<section className='section-padding' id='reviews'>
			<Title
				title={
					<span>
						Am Ende zählt nur, <br />
						was unsere Kunden über uns sagen.
					</span>
				}
			/>

			<div className='stream'>
				<Carousel
					autoHeight={false}
					disableButtonsControls={true}
					items={slides}
					activeIndex={activeIndex}
					onSlideChanged={onSlideChange}
					responsive={responsive}
				/>
			</div>
		</section>
	);
};

export default Reviews;
